var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextanalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.776,
    height: 53.15,
    viewBox: "0 0 41.776 53.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.328 -2.24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.578 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.284,55.141H8.138a.56.56,0,0,1-.56-.56V3.06a.56.56,0,0,1,.56-.56h29.93a.558.558,0,0,1,.417.186L48.7,14.086a.56.56,0,0,1,.143.374V54.581A.56.56,0,0,1,48.284,55.141ZM8.7,54.021H47.724V14.674L37.817,3.62H8.7Z",
    transform: "translate(-7.578 -2.5)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.93 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.077,15.019H34.861a.56.56,0,0,1-.56-.56V3.06a.56.56,0,0,1,.977-.374l10.216,11.4a.56.56,0,0,1-.417.934ZM35.421,13.9h8.4l-8.4-9.375Z",
    transform: "translate(-34.301 -2.5)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.188 7.026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.217,9.893H13.664a.56.56,0,0,1,0-1.12H28.217a.56.56,0,0,1,0,1.12Z",
    transform: "translate(-13.104 -8.773)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.188 13.716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.525,15.867H13.663a.56.56,0,0,1,0-1.12h7.862a.56.56,0,0,1,0,1.12Z",
    transform: "translate(-13.103 -14.747)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.749 21.091)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.057 15.102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.219,41.659a3.422,3.422,0,1,1,3.421-3.422A3.426,3.426,0,0,1,24.219,41.659Zm0-5.724a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,24.219,35.935Z",
    transform: "translate(-20.797 -34.815)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.676,29.477A4.073,4.073,0,1,1,21.749,25.4,4.077,4.077,0,0,1,17.676,29.477Zm0-7.026A2.953,2.953,0,1,0,20.629,25.4,2.956,2.956,0,0,0,17.676,22.451Z",
    transform: "translate(-13.604 -21.331)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.569 3.549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.568,31.7a3.6,3.6,0,1,1,3.6-3.6A3.6,3.6,0,0,1,35.568,31.7Zm0-6.08a2.48,2.48,0,1,0,2.48,2.48A2.483,2.483,0,0,0,35.568,25.62Z",
    transform: "translate(-31.969 -24.5)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.208 6.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.787,37.45a.56.56,0,0,1-.513-.336L18.3,28a.56.56,0,1,1,1.026-.447L23.3,36.666a.559.559,0,0,1-.513.784Z",
    transform: "translate(-18.253 -27.215)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.307 8.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.044,37.9a.56.56,0,0,1-.38-.972L33.9,29.345a.56.56,0,0,1,.759.825l-8.239,7.581A.56.56,0,0,1,26.044,37.9Z",
    transform: "translate(-25.484 -29.197)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextanalytics);
export default __webpack_public_path__ + "static/media/textanalytics.ba205014.svg";
export { ForwardRef as ReactComponent };